import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const MedicalTeam = () => {
    const { t, i18n } = useTranslation();
    const [team, setTeam] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const res = await axios.get('https://hasanhaji.com/api/team');
                setTeam(res.data.data.teamMembers);
                setLoading(false);
            } catch (err) {
                console.error('Error fetching team:', err);
                setError('حدث خطأ أثناء تحميل الفريق الطبي. الرجاء المحاولة مرة أخرى.');
                setLoading(false);
            }
        };

        fetchTeam();
    }, []);

    return (
        <div className="container py-5">
            <h2 className="section-title">{t('home.doctors.title')}</h2>
            <p className="text-center text-muted mb-5">{t('home.doctors.subtitle')}</p>

            {loading ? (
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">{t('home.doctors.loading')}</span>
                    </div>
                </div>
            ) : error ? (
                <div className="alert alert-danger text-center" role="alert">
                    {t('home.doctors.error')}
                </div>
            ) : team.length === 0 ? (
                <p className="text-center text-muted">
                    {t('home.doctors.noTeam')}
                </p>
            ) : (
                <div className="row justify-content-center">
                    {team.filter(member => member.jobTitle !== 'Nurse').map((member) => (
                        <div className="col-lg-4 col-md-6 mb-4" key={member.id}>
                            <div className="doctor-card h-100">
                                <div className="doctor-image">
                                    <img
                                        src={member.image || '/images/doctors/dr-hassan.jpg'}
                                        alt={member.nameAr || member.name}
                                    />
                                </div>
                                <div className="doctor-info">
                                    <h3>{i18n.language === 'ar' ? (member.nameAr || member.name) : (member.nameEn || member.name)}</h3>
                                    <p className="specialty">
                                        {i18n.language === 'ar'
                                            ? (member.specialtyAr || member.specialty)
                                            : (member.specialtyEn || member.specialty)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MedicalTeam;
